import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class MyInvoiceService {

    constructor(private _http: HttpClient) { }

    invoicerecords(data) {
        return this._http.post(environment.api_url + 'seller/report/myinvoice', data);
    }

    subsellerinvoice(data) {
        return this._http.post(environment.api_url + 'seller/report/subsellerinvoice', data);
    }

}